<template>
  <auth-base
    entry="login"
    :on-submit="changePass"
    :error="errorMessage"
    :headerText="$t('auth.header.forgot')"
    :loading="loading"
    @errorClose="errorMessage = false"
  >
    <div class="formgroup">
      <div class="field" :class="{ filled: filled.password }">
        <label for="password">{{ $t('auth.password') }}</label>
        <input
          type="password"
          name="password"
          id="password"
          class="login-field ym-disable-keys"
          :class="{ error: errored.password }"
          autocomplete="current-password"
          @input="(e) => checkFilled('password', e) || resetErrors()"
          @animationstart="(e) => checkAnimation('password', e)"
          v-model="password"
          tabindex="2"
        />
      </div>
    </div>
    <input
      class="submit"
      type="submit"
      :value="$t('auth.buttons.newPass')"
      tabindex="3"
    />
    <p class="links">
      <router-link to="/auth/login">{{ $t('auth.rememberLink') }}</router-link>
    </p>
  </auth-base>
</template>

<script>
import baseMixin from './baseMixin'

export default {
  name: 'AuthLogin',
  mixins: [baseMixin],
}
</script>

<style lang="scss"></style>
